module.exports = __webpack_public_path__ + "img/bs.db3ec0fa.svg";